import * as angular from "angular";
import {IComponentController, ITimeoutService} from "angular";
import parsePhoneNumber, {CountryCode} from 'libphonenumber-js'

class InputPhoneController implements IComponentController {
    input: any;
    model: string;
    countryCode: CountryCode;
    private copied: boolean;
    private suggested: string;
    private warning: string;

    constructor(private $timeout: ITimeoutService) {
    }

    $onInit(): void {
    }

    copy = () => {
        console.debug('copy', this.input);
        this.input.select();
        document.execCommand('copy');
        this.copied = true;
        this.$timeout(() => this.copied = false, 2000);

    }

    validate = () => {
        if(!this.model) {
            this.suggested=null;
            this.warning=null;
            return;
        }
        const phoneNumber = parsePhoneNumber(this.model, this.countryCode || 'US');
        console.log(this.model, phoneNumber, phoneNumber?.formatInternational());
        if(phoneNumber) {
            this.suggested=null;
            this.warning=null;
            if(this.model == phoneNumber.formatInternational()) {
                return;
            }
            this.suggested = phoneNumber.formatInternational();
        } else {
            this.warning = "Invalid phone number";
            this.suggested = null;
        }

    }
}

export default angular.module('component.inputPhone', [])
    .component('inputPhone', {
        template: require('./InputPhone.html'),
        controller: InputPhoneController,
        controllerAs: '$ctrl',
        bindings: {
            model: '=',
            value: '=',
            required: '=',
            readonly: '=',
            disabled: '=',
            placeholder: '@',
            class: '@',
            showCopy: '=',
            countryCode: '='
        }
    }).name;
